module.exports = __webpack_public_path__ + "./assets/water-50adfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/water.png
// module id = 12
// module chunks = 0